import { render, staticRenderFns } from "./rotating-headers.vue?vue&type=template&id=a48fdee8&scoped=true&"
import script from "./rotating-headers.vue?vue&type=script&lang=js&"
export * from "./rotating-headers.vue?vue&type=script&lang=js&"
import style0 from "./rotating-headers.vue?vue&type=style&index=0&id=a48fdee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48fdee8",
  null
  
)

export default component.exports